<template>
  <div class="pa-1" style="margin-bottom: 16px; margin-left: 2px;">
    <k-layout>
      <k-flex c10> {{label || title}}</k-flex>
      <k-flex c2>
        <k-btn color="info" size="xs" @click="add_line">Add</k-btn>
      </k-flex>
    </k-layout>

    <k-layout row v-for="(v, idx) in val" :key="idx" class="elevation-1 pa-1" style="margin-bottom: 16px; margin-left: 2px;">
      <k-flex c11>
          <k-layout :row="direction == 'row'" :column="direction != 'row'">
            <k-flex v-for="field in form" :key="field.name">
              <div v-if="field.type == 'group'">
                <div v-for="gfield in field.fields">
                  <component v-bind:is="get_field_type(gfield.type)" v-bind="gfield" v-model="v.data" :ref="gfield.name"></component>
                </div>
              </div>
              <div v-else>
                <component v-bind:is="get_field_type(field.type)" v-bind="field" v-model="v.data" :ref="field.name"></component>
              </div>
            </k-flex>
          </k-layout>
      </k-flex>
      <k-flex c1>
        <k-icon right @click.stop="del_line(idx)">delete</k-icon>
      </k-flex>
    </k-layout>
</div>
</template>

<script>

import * as FormItems from '@/components/form_items'

import {EventMixin} from '@/lib/mixins.js';
import ContentModel from '@/models/content.js'

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'name',
    'label',
    'title',
    'form',
    'direction'
  ],
  components: {
    ...FormItems
  },
  methods: {
    get_field_type(field_type) {
      return ContentModel.get_field_type(field_type);
    },
    add_line () {
      var new_val = this.val;
      new_val.push({data: {}});
      this.val = new_val;
    },
    del_line (idx) {
      var new_list = this.val;
      new_list.splice(idx,1);
      this.val = new_list;
    }
  },
  computed: {
    val: {
      get () {
        var ret = _.get(this.value, this.name) || [];
        if (!_.isArray(ret)) ret = [];
        return ret;
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
